module.exports = __webpack_public_path__ + "img/画板 3@3x.7328180d.png";